import { CSSProperties } from "@material-ui/core/styles/withStyles";

// styles
// import { colors } from '@clockwise/web-commons/src/styles/color.styles';

const backdrop: CSSProperties = {
  background: `rgba(255, 255, 255, 0.85)`,
};

const paper: CSSProperties = {
  maxWidth: 1200,
  width: "calc(100% - 64px)",
  height: "calc(100% - 64px)",
  top: "50%",
  transform: "translateY(calc(-50% - 32px))",
  margin: 32,
  boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
};

const rounded: CSSProperties = {
  borderRadius: 10,
};

export const styles = {
  backdrop,
  paper,
  rounded,
};
